/**
 * Type of alert messages. String constants are specific for ngx-alert type parameter.
 */
export enum AppMessageTypeEnum {
    INFO = 'info',
    WARNING = 'warning',
    ERROR = 'danger',
    SUCCESS = 'success'
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/enums/app-message-type.enum.ts